import { useState, useMemo } from "react";

export default function SceltaComuni({
  nome,
  comuni,
  selezionati,
  setSelezionati,
  onSalva,
}) {
  const [search, setSearch] = useState("");

  // filtro dinamico (solo se search non è vuota)
  const comuniFiltrati = useMemo(() => {
    const s = search.trim().toLowerCase();
    if (s === "") return [];
    return comuni.filter((c) => c.toLowerCase().startsWith(s));
  }, [search, comuni]);

  // selezione/deselezione comune
  const toggleComune = (comune) => {
    setSelezionati((prev) =>
      prev.includes(comune)
        ? prev.filter((c) => c !== comune)
        : [...prev, comune]
    );
  };

  const handleSubmit = (e) => {e.preventDefault(); onSalva();};

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="font-semibold mb-4">
        Comprensorio:{" "}
        <span style={{ color: "green", fontWeight: "bold" }}>{nome}</span>
      </h3>

      {/* barra di ricerca */}
      <input
        type="text"
        placeholder="Cerca comune..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border p-2 w-full mb-3"
      />

      {/* lista filtrata visibile SOLO se c’è testo */}
      {search.trim() !== "" && (
        <div className="max-h-60 overflow-y-auto border p-2 rounded">
          {comuniFiltrati.length === 0 ? (
            <p className="text-gray-500">Nessun comune trovato</p>
          ) : (
            comuniFiltrati.map((comune) => (
              <label key={comune} className="block cursor-pointer ms-2">
                <input
                  type="checkbox"
                  checked={selezionati.includes(comune)}
                  onChange={() => toggleComune(comune)}
                />
                <span className="ms-1">{comune}</span>
              </label>
            ))
          )}
        </div>
      )}

      {/* lista dei selezionati */}
      {selezionati.length > 0 && (
        <div className="mt-3">
          <h4 className="font-semibold">Comuni selezionati:</h4>
          <ul className="list-disc ps-4">
            {selezionati.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>
      )}

      <button type="submit" className="btn btn-success ms-3 mt-3">
        Salva Comprensorio
      </button>
    </form>
  );
}
